import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

export function useAuth(handleRedirect: boolean = false) {
    const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate();

    const isAdmin = user?.utype === 'ADMIN';

    useEffect(() => {
        if (handleRedirect) {
            if (!isAuthenticated) {
                navigate('/login');
            } else {
                navigate('/dashboard');
            }
        }
    }, [isAuthenticated, navigate, handleRedirect]);

    return { isAuthenticated, user, isAdmin };
}